class MobileQuickAdd extends HTMLElement {
  constructor () {super()
  this.attachEvents()
  }

  attachEvents(){
    const picker = this.querySelector('[data-variant-picker]');
    if (!picker) return;

    const toggle = picker.querySelector('[data-dropdown-toggle]');
    const list = picker.querySelector('[data-dropdown-list]');
    const selectedEl = picker.querySelector('[data-dropdown-selected]');
    const hiddenInput = picker.querySelector('[data-variant-input]');
    const addToCartBtn = this.querySelector('button[type="submit"]')
    toggle.addEventListener('click', () => {
      list.classList.toggle('open');
      toggle.classList.toggle('open');
    });

    list.querySelectorAll('.dropdown-item').forEach(item => {
      item.addEventListener('click', () => {
        const optionText = item.getAttribute('data-option');
        const variantId = item.getAttribute('data-value');
        const price = item.getAttribute('data-price');
        addToCartBtn.querySelector('div').textContent=`Add | Dhs. ${price}`
        selectedEl.innerHTML = `
        <span data-dropdown-selected>
${optionText} <svg width="15" height="15" viewBox="0 0 15 15"
 fill="none"
 xmlns="http://www.w3.org/2000/svg">
<path d="M11.875 5.625L7.5 10L3.125 5.625" stroke="#111827" stroke-linecap="round" stroke-linejoin="round"/>
</svg></span>`;
        hiddenInput.value = variantId;

        list.classList.remove('open');
        toggle.classList.remove('open');
      });
    });

    document.addEventListener('click', (e) => {
      if (!picker.contains(e.target)) {
        list.classList.remove('open');
        toggle.classList.remove('open');
      }
    });
  }

}
window.customElements.define("mobile-quick-add", MobileQuickAdd);
